var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72861 9.19801H9.25552L9.08784 9.03631C9.695 8.33207 10.0287 7.433 10.028 6.50316C10.028 5.73328 9.79975 4.98069 9.37203 4.34057C8.94431 3.70044 8.33637 3.20152 7.6251 2.9069C6.91383 2.61228 6.13116 2.5352 5.37608 2.68539C4.621 2.83559 3.92741 3.20632 3.38303 3.7507C2.83864 4.29509 2.46791 4.98867 2.31772 5.74376C2.16752 6.49884 2.24461 7.2815 2.53923 7.99277C2.83384 8.70405 3.33276 9.31198 3.97289 9.7397C4.61302 10.1674 5.36561 10.3957 6.13548 10.3957C7.09964 10.3957 7.98594 10.0424 8.66864 9.45551L8.83033 9.62319V10.0963L11.8246 13.0846L12.7169 12.1923L9.72861 9.19801ZM6.13548 9.19801C4.64433 9.19801 3.44063 7.99431 3.44063 6.50316C3.44063 5.01201 4.64433 3.80831 6.13548 3.80831C7.62663 3.80831 8.83033 5.01201 8.83033 6.50316C8.83033 7.99431 7.62663 9.19801 6.13548 9.19801ZM6.43491 5.00602H5.83605V6.20373H4.63834V6.80258H5.83605V8.00029H6.43491V6.80258H7.63262V6.20373H6.43491V5.00602Z",
    fill: "#4A4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.331bb6468ac06277c674d30787475820.svg";
export { ForwardRef as ReactComponent };